import { Controller } from '@hotwired/stimulus'
import dialogPolyfill from 'dialog-polyfill'
import { waitForAnimations } from '../utils'

// Connects to data-controller="turbo-modal"
// Opens a <dialog> when the inner turbo-frame receives content,
// and resets the frame when the dialog is closed.
export default class extends Controller {
  static targets = ['dialog', 'animationsHolder', 'frame', 'title']

  initialize() {
    dialogPolyfill.registerDialog(this.dialogTarget)
  }

  connect() {
    this.frameTarget.addEventListener('turbo:frame-load', this.#onFrameLoad)
    document.addEventListener('turbo:before-render', this.#forceClose)
  }

  disconnect() {
    this.frameTarget.removeEventListener('turbo:frame-load', this.#onFrameLoad)
    document.removeEventListener('turbo:before-render', this.#forceClose)
  }

  close(_event) {
    this.dialogTarget.setAttribute('closing', '')
    waitForAnimations(this.animationsHolderTarget).then(() => {
      this.dialogTarget.removeAttribute('closing')
      this.dialogTarget.close()
      // close() rend le focus au déclencheur : on le relâche, comme à l’ouverture.
      document.activeElement?.blur()
      this.#resetFrame()
    })
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  #onFrameLoad = () => {
    // Lit data-modal-title sur l'élément racine du contenu chargé dans la frame.
    const title = this.frameTarget.querySelector('[data-modal-title]')?.dataset.modalTitle
    if (this.hasTitleTarget) this.titleTarget.textContent = title ?? ''
    // Déjà ouverte : un formulaire refusé s'y réaffiche (gods_form_controller).
    if (this.dialogTarget.open) return
    this.dialogTarget.showModal()
    document.activeElement?.blur()
  }

  #forceClose = () => {
    this.dialogTarget.close()
    document.activeElement?.blur()
    this.#resetFrame()
  }

  #resetFrame() {
    if (this.hasTitleTarget) this.titleTarget.textContent = ''
    this.frameTarget.removeAttribute('src')
    this.frameTarget.innerHTML = ''
  }
}
